import { memo } from 'react';
import { classes } from './config';
import { LoaderContent } from './loaderContent';
import type { LoaderProps } from './types';

function Loader(props: Readonly<LoaderProps>) {
  return (
    <div className={classes.rootWrapper}>
      <div className={classes.contentWrapper}>
        <LoaderContent {...props} />
      </div>
    </div>
  );
}

const MemoizedLoader = memo(Loader);

export { MemoizedLoader as Loader };
